import React, { useContext, useState } from 'react';
import './MinimalRuneDisplay.css';
import GameAssetsContext from '../../../../../context/GameAssetContext';
import SimpleRuneDisplay from './SimpleRuneDisplay';
import { ShardNames } from '../../../../../BuildOverview/runeConfig';
import { SimplifiedChampion, SimplifiedRunePage } from '../../../../../gameTypes';
import { runeIdMapping, runeIdToStyleName, getRuneImageUrl } from '../../../../../../NewWebSocket/utils/runeIdMapping';
import { RUNE_TREE_IMAGES } from '../../../../../../NewWebSocket/utils/runeConfig';

interface MinimalRuneDisplayProps {
  primaryRunes: string[];
  secondaryRunes: string[];
  shards: ShardNames[];
  championId: string;
  runePage: SimplifiedRunePage;
  champion: SimplifiedChampion;
}

const MinimalRuneDisplay: React.FC<MinimalRuneDisplayProps> = ({
  primaryRunes,
  secondaryRunes,
  shards,
  championId,
  runePage,
  champion
}) => {
  const { gameWideAssets } = useContext(GameAssetsContext);
  
  const [isHover, setIsHover] = useState(false);

  // Get keystone rune (should be second item in primaryRunes array)
  const keystoneRune = primaryRunes[1];
  // Get secondary tree style (first item in secondaryRunes array)
  const secondaryTree = secondaryRunes[0];

  // Get image URLs
  const getRuneImageUrlForDisplay = (runeId: string): string => {
    const numericRuneId = parseInt(runeId);
    if (!isNaN(numericRuneId) && runeIdMapping[numericRuneId]?.path) {
      return `https://ddragon.leagueoflegends.com/cdn/img/perk-images/${runeIdMapping[numericRuneId].path}`;
    }
    // Fallback to gameWideAssets if we don't have a mapping
    return gameWideAssets.runes[runeId] || '';
  };

  const getTreeImageUrl = (styleId: string): string => {
    // Map the numeric ID to the style name and use the shared RUNE_TREE_IMAGES
    const styleName = runeIdToStyleName[styleId];
    if (styleName && RUNE_TREE_IMAGES[styleName]) {
      return RUNE_TREE_IMAGES[styleName];
    }
    // Fallback to gameWideAssets
    return gameWideAssets.runeTrees[styleId] || '';
  };

  const keystoneImage = getRuneImageUrlForDisplay(keystoneRune);
  const secondaryTreeImage = getTreeImageUrl(secondaryTree);

  const handleMouseEnter = () => {
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
  };

  return (
    <div
      className="minimal-rune-display"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="keystone-image-wrapper">
        <img src={keystoneImage} alt={runeIdMapping[parseInt(keystoneRune)]?.name || "Keystone Rune"} className="keystone-image" />
      </div>
      <div className="secondary-tree-image-wrapper">
        <img src={secondaryTreeImage} alt={runeIdMapping[parseInt(secondaryTree)]?.name || "Secondary Rune Tree"} className="secondary-tree-image" />
      </div>
      
      {isHover && (
        <div className="hover-content">
          <SimpleRuneDisplay
            primaryRunes={primaryRunes}
            secondaryRunes={secondaryRunes}
            shards={shards}
            championId={championId}
            runePage={runePage}
            champion={champion}
          />
        </div>
      )}
    </div>
  );
};

export default MinimalRuneDisplay;
